export default {
  data() {
    return {
      menu: [
        {
          id: 'A',
          parentId: '',
          name: this.$t('menu.statistics.abap'),
          children: [
            {
              id: 'A0',
              parentId: 'A',
              name: this.$t('menu.statistics.abap.ci'),
              // BEGIN::Modified.and.added.by.KWShin.2023.08.10.
              // children: [
              //   {
              //     id: 'A00',
              //     parentId: 'A0',
              //     name: this.$t('menu.statistics.abap.update.record'),
              //     data: { code: 'STTS_ABAP_UPDATE_RECORD', target: 'system', emptyToZero: true },
              //   },
              //   {
              //     id: 'A01',
              //     parentId: 'A0',
              //     name: this.$t('menu.statistics.abap.dump'),
              //     data: { code: 'STTS_ABAP_DUMP', target: 'system', emptyToZero: true },
              //   },
              //   {
              //     id: 'A02',
              //     parentId: 'A0',
              //     name: this.$t('menu.statistics.abap.locks'),
              //     data: { code: 'STTS_ABAP_LOCKS', target: 'system', emptyToZero: true },
              //   },
              // ],
              children: [
                {
                  id: 'A00',
                  parentId: 'A0',
                  name: this.$t('menu.statistics.abap.dump'),
                  data: { code: 'STTS_ABAP_DUMP', target: 'system', emptyToZero: true },
                },
                {
                  id: 'A01',
                  parentId: 'A0',
                  name: this.$t('menu.statistics.abap.syslog'),
                  data: { code: 'STTS_ABAP_SYSLOG', target: 'system', emptyToZero: true },
                },
                {
                  id: 'A02',
                  parentId: 'A0',
                  name: this.$t('menu.statistics.abap.applog'),
                  data: { code: 'STTS_ABAP_APPLOG', target: 'system', emptyToZero: true },
                },
                {
                  id: 'A03',
                  parentId: 'A0',
                  name: this.$t('menu.statistics.abap.locks'),
                  data: { code: 'STTS_ABAP_LOCKS', target: 'system', emptyToZero: true },
                },
                {
                  id: 'A04',
                  parentId: 'A0',
                  name: this.$t('menu.statistics.abap.update.record'),
                  data: { code: 'STTS_ABAP_UPDATE_RECORD', target: 'system', emptyToZero: true },
                },
              ],
              // FINISH::Modified.and.added.by.KWShin.2023.08.10.
            },
            {
              id: 'A1',
              parentId: 'A',
              name: this.$t('menu.statistics.abap.user'),
              children: [
                {
                  id: 'A10',
                  parentId: 'A1',
                  name: this.$t('menu.statistics.abap.user.logon'),
                  data: { code: 'STTS_ABAP_USER_LOGON', target: 'instance' },
                },
                {
                  id: 'A11',
                  parentId: 'A1',
                  name: this.$t('menu.statistics.abap.user.dup.id'),
                  data: { code: 'STTS_ABAP_USER_DUP', target: 'system', emptyToZero: true },
                },
              ],
            },
            {
              id: 'A2',
              parentId: 'A',
              name: this.$t('menu.statistics.abap.os'),
              children: [
                {
                  id: 'A20',
                  parentId: 'A2',
                  name: this.$t('menu.statistics.abap.os.cpu'),
                  data: { code: 'STTS_ABAP_OS_CPU', target: 'instance' },
                },
                {
                  id: 'A21',
                  parentId: 'A2',
                  name: this.$t('menu.statistics.abap.os.memory'),
                  data: { code: 'STTS_ABAP_OS_MEMORY', target: 'instance' },
                },
                {
                  id: 'A22',
                  parentId: 'A2',
                  name: this.$t('menu.statistics.abap.os.disk'),
                  data: { code: 'STTS_ABAP_OS_DISK', target: 'element' },
                },
                {
                  id: 'A23',
                  parentId: 'A2',
                  name: this.$t('menu.statistics.abap.os.fsys'),
                  data: { code: 'STTS_ABAP_OS_FSYS', target: 'element' },
                },
                {
                  id: 'A24',
                  parentId: 'A2',
                  name: this.$t('menu.statistics.abap.os.network'),
                  data: { code: 'STTS_ABAP_OS_NTWK', target: 'element' },
                },
              ],
            },
            {
              id: 'A3',
              parentId: 'A',
              name: this.$t('menu.statistics.abap.process'),
              children: [
                {
                  id: 'A30',
                  parentId: 'A3',
                  name: this.$t('menu.statistics.abap.queue'),
                  data: { code: 'STTS_ABAP_QUEUE', target: 'instance' },
                },
                {
                  id: 'A31',
                  parentId: 'A3',
                  name: this.$t('menu.statistics.abap.work.process'),
                  data: { code: 'STTS_ABAP_WORK_PROCESS', target: 'instance' },
                },
                // {
                //   id: 'A32',
                //   parentId: 'A3',
                //   name: this.$t('menu.statistics.abap.sap.buffer'),
                //   data: { code: 'STTS_ABAP_SAP_BUFFER', target: 'element' },
                // },
                // {
                //   id: 'A33',
                //   parentId: 'A3',
                //   name: this.$t('menu.statistics.abap.sap.memory'),
                //   data: { code: 'STTS_ABAP_SAP_MEMORY', target: 'element' },
                // },
                {
                  id: 'A32',
                  parentId: 'A3',
                  name: this.$t('menu.statistics.abap.workprcs.load'),
                  data: { code: 'STTS_ABAP_WORKPRCS_LOAD', target: 'element' },
                },
                {
                  id: 'A33',
                  parentId: 'A3',
                  name: this.$t('menu.statistics.abap.sap.buffer'),
                  data: { code: 'STTS_ABAP_SAP_BUFFER', target: 'element' },
                },
                {
                  id: 'A34',
                  parentId: 'A3',
                  name: this.$t('menu.statistics.abap.sap.memory'),
                  data: { code: 'STTS_ABAP_SAP_MEMORY', target: 'element' },
                },
              ],
            },
            {
              id: 'A4',
              parentId: '',
              name: this.$t('menu.statistics.abap.transaction'),
              children: [
                {
                  id: 'A40',
                  parentId: 'A4',
                  name: this.$t('menu.statistics.abap.transaction.per.task.type'),
                  data: { code: 'STTS_ABAP_TRXN_TASK_TYPE', target: 'element' },
                },
                {
                  id: 'A41',
                  parentId: 'A4',
                  name: this.$t('menu.statistics.abap.transaction.per.user'),
                  data: { code: 'STTS_ABAP_TRXN_USER', target: 'system' },
                },
                {
                  id: 'A42',
                  parentId: 'A4',
                  name: this.$t('menu.statistics.abap.transaction.per.report'),
                  data: { code: 'STTS_ABAP_TRXN_REPORT', target: 'system' },
                },
                {
                  id: 'A43',
                  parentId: 'A4',
                  name: this.$t('menu.statistics.abap.transaction.per.tcode'),
                  data: { code: 'STTS_ABAP_TRXN_TCODE', target: 'system' },
                },
              ],
            },
          ],
        },
        {
          id: 'J',
          parentId: '',
          name: this.$t('menu.statistics.java'),
          children: [
            {
              id: 'J0',
              parentId: 'J',
              name: this.$t('menu.statistics.java.os'),
              children: [
                {
                  id: 'J00',
                  parentId: 'J0',
                  name: this.$t('menu.statistics.java.os.cpu'),
                  data: { code: 'STTS_JAVA_OS_CPU', target: 'instance' },
                },
                {
                  id: 'J01',
                  parentId: 'J0',
                  name: this.$t('menu.statistics.java.os.memory'),
                  data: { code: 'STTS_JAVA_OS_MEM', target: 'instance' },
                },
                {
                  id: 'J02',
                  parentId: 'J0',
                  name: this.$t('menu.statistics.java.os.disk'),
                  data: { code: 'STTS_JAVA_OS_DISK', target: 'element' },
                },
                {
                  id: 'J03',
                  parentId: 'J0',
                  name: this.$t('menu.statistics.java.os.fsys'),
                  data: { code: 'STTS_JAVA_OS_FSYS', target: 'element' },
                },
                {
                  id: 'J04',
                  parentId: 'J0',
                  name: this.$t('menu.statistics.java.os.network'),
                  data: { code: 'STTS_JAVA_OS_NTWK', target: 'element' },
                },
              ],
            },
            {
              id: 'J1',
              parentId: 'J',
              name: this.$t('menu.statistics.java.user'),
              children: [
                {
                  id: 'J10',
                  parentId: 'J1',
                  name: this.$t('menu.statistics.java.http.session'),
                  data: { code: 'STTS_JAVA_HTTP_SSSN', target: 'node' },
                },
              ],
            },
            {
              id: 'J2',
              parentId: 'J',
              name: this.$t('menu.statistics.java.jvm'),
              children: [
                {
                  id: 'J20',
                  parentId: 'J2',
                  name: this.$t('menu.statistics.java.heap.memory'),
                  data: { code: 'STTS_JAVA_HEAP_MEMORY', target: 'node' },
                },
                {
                  id: 'J21',
                  parentId: 'J2',
                  name: this.$t('menu.statistics.java.thread.system'),
                  data: { code: 'STTS_JAVA_SSTM_THRD', target: 'node' },
                },
                {
                  id: 'J22',
                  parentId: 'J2',
                  name: this.$t('menu.statistics.java.thread.application'),
                  data: { code: 'STTS_JAVA_APPL_THRD', target: 'node' },
                },
              ],
            },
            {
              id: 'J3',
              parentId: 'J',
              name: this.$t('menu.statistics.java.database'),
              children: [
                {
                  id: 'J30',
                  parentId: 'J3',
                  name: this.$t('menu.statistics.java.transaction'),
                  data: { code: 'STTS_JAVA_TRXN', target: 'node' },
                },
              ],
            },
            {
              id: 'J4',
              parentId: 'J',
              name: this.$t('menu.statistics.java.miscellaneous'),
              children: [
                {
                  id: 'J40',
                  parentId: 'J4',
                  name: this.$t('menu.statistics.java.http'),
                  data: { code: 'STTS_JAVA_HTTP_PRVDR', target: 'node' },
                },
                {
                  id: 'J41',
                  parentId: 'J4',
                  name: this.$t('menu.statistics.java.jsp'),
                  data: { code: 'STTS_JAVA_JSP', target: 'node' },
                },
                {
                  id: 'J42',
                  parentId: 'J4',
                  name: this.$t('menu.statistics.java.p4'),
                  data: { code: 'STTS_JAVA_P4', target: 'node' },
                },
                {
                  id: 'J43',
                  parentId: 'J4',
                  name: this.$t('menu.statistics.java.enqueue.lock'),
                  data: { code: 'STTS_JAVA_ENQUEUE_LOCK', target: 'node' },
                },
                {
                  id: 'J44',
                  parentId: 'J4',
                  name: this.$t('menu.statistics.java.log.size'),
                  data: { code: 'STTS_JAVA_LOG_SIZE', target: 'node' },
                },
                {
                  id: 'J45',
                  parentId: 'J4',
                  name: this.$t('menu.statistics.java.service.status'),
                  data: { code: 'STTS_JAVA_SVC_STATUS', target: 'node' },
                },
                {
                  id: 'J46',
                  parentId: 'J4',
                  name: this.$t('menu.statistics.java.class.loader'),
                  data: { code: 'STTS_JAVA_CLASS_LDR', target: 'node' },
                },
              ],
            },
          ],
        },
      ],
    };
  },
};
